export const EnLocale = {
    page: {
        txtTitle: 'UNVOX | Remove vocals instantly',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'unvox logo',
        },
        action: {
            txtBack: 'Back',
            txtRetry: 'Retry',
            txtStartOver: 'Start over',
        },
        job: {
            txtCheckingStatus: 'Checking job status',
            txtIdLabel: 'Job ID',
        },
        footer: {
            linkPrivacyPolicy: 'Privacy Policy',
            linkTerms: 'Terms',
            linkRefunds: 'Refunds',
            linkSupport: 'Support',
            txtAllRightsReserved: 'All Rights Reserved.',
            txtBugReportsAndFeatures: 'Bug reports and feature requests',
        },
        share: {
            title: 'UNVOX | One click remove of song vocals',
            text: 'Easily turn your favorite songs into karaoke ready instrumentals!',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'One-click vocal removal',
            txtHeroSubtitle: 'Instant instrumentals from your track or direct from YouTube',
            txtInputTypeLabel: 'Input type',
            txtInputTypeFile: 'Upload audio file',
            txtInputTypeYoutube: 'YouTube link',
            txtInputFilePick: 'Choose File',
            txtInputFileSub: 'Common audio formats ({{formats}}), up to {{size}} MB.',
            txtPreviewAction: 'Remove vocals',
            txtPreviewFailed: 'An unknown error occurred. Please try again later.',
            txtUploadSelectFile: 'No file chosen yet',
            txtYoutubeLabel: 'YouTube URL',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: 'Paste a public YouTube link.',
            txtYoutubeMissing: 'Please paste a YouTube URL.',
            txtYoutubeInvalid: 'Enter a valid YouTube URL.',
            txtYoutubeTooLong: 'This video is longer than 15 minutes. Please choose a shorter video.',
            txtCheckoutUploadFailed: 'Upload failed. Please try again.',
            txtUploadMissing: 'Please choose a file before uploading.',
            txtFileTypeInvalid: 'Unsupported file type. Please upload an audio file (e.g. {{formats}}).',
            txtFileTooLarge: 'File is too large. Max size is {{size}} MB.',
        },
        previewJob: {
            txtUnavailableTitle: 'Unable to create preview',
            txtUnavailableBody: 'An unknown error occurred. Please try again later.',
            txtPreparingTitle: 'Preparing preview',
            txtPreparingBody: 'This may take up to 2 minutes',
        },
        payment: {
            txtUnavailableTitle: 'Unable to create preview',
            txtUnavailableBody: 'An unknown error occurred. Please try again later.',
            txtPreparingTitle: 'Preparing preview',
            txtCheckoutCancelledBody: 'No charge was made. You can try again anytime.',
            txtTrackPreviewLabel: 'Track preview',
            txtTrackPreviewHelper: 'This preview is a 15 second clip of your track for evaluation',
            txtEmailLabel: 'Email address',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'We will use this to deliver your download link.',
            txtCheckoutAction: 'Remove vocals for only {{price}}',
            txtCheckoutActionFallback: 'Remove vocals',
            txtCheckoutFailed: 'Unable to start checkout. Please try again.',
            txtInvalidEmail: 'Enter a valid email address.',
        },
        processing: {
            txtMissingTitle: 'Missing job id',
            txtMissingBody: 'This page needs a job id. Please start a new preview.',
            txtMissingAction: 'Back to upload',
            txtStatusFailed: 'Unable to fetch job status. Please try again.',
            txtErrorTitle: 'Something went wrong',
            txtSupportAction: 'Contact support',
            txtConfirmingTitle: 'Confirming payment',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: 'Checking for updates',
            txtWorkingTitle: 'Processing your full track',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: 'Start another',
            txtReadyTitle: 'Download ready',
            txtReadyBody: 'Your instrumental is ready to download.',
            txtDownloadAction: 'Download',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: 'Start another',
        },
        invalidJob: {
            txtTitle: 'Invalid job id',
            txtBody: 'That job could not be found. Please start a new upload.',
            txtAction: 'Start over',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'Support',
            txtTitle: 'Contact Support',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 9, 2026',
            txtSectionEmailTitle: 'Email',
            txtSectionEmailBodyPrefix: 'Email us at',
            txtSectionIncludeJobIdTitle: 'Include Your Job ID',
            txtSectionIncludeJobIdBody: 'Please include your job ID so we can locate your job quickly. If you paid, include the email address used at checkout.',
            txtSectionBugReportsTitle: 'Bug Reports',
            txtSectionBugReportsBody: 'You can also submit bug reports and feature requests via the link in the footer.',
        },
        bugReportsFeatures: {
            txtEyebrow: 'Feedback',
            txtTitle: 'Bug reports and feature requests',
            txtSubtitle: 'UNVOX is early. If something feels off or you have an idea, send it. Clear reports are the fastest way to get fixes shipped.',
            txtWhatToIncludeTitle: 'What to include',
            txtChecklistExpectedVsActual: 'What you expected vs what happened',
            txtChecklistSteps: 'Steps to reproduce (1, 2, 3)',
            txtChecklistBrowserOs: 'Your browser and OS',
            txtChecklistJobId: 'Job ID (if it involved an upload)',
            txtTipTitle: 'Tip',
            txtTipBody: 'If you are emailing us, you can reply directly to the delivery email you received and paste the template.',
            txtTemplateTitle: 'Copy-paste template',
            txtTemplateBody: 'Bug report / Feature request\n\nType: bug | feature\nSummary:\n\nDetails:\n- What happened:\n- What you expected:\n- Steps to reproduce:\n  1.\n- Browser/OS:\n\nOptional:\n- Job ID:\n- YouTube URL:\n- Screenshot/video:\n',
            txtTemplatePageLabel: 'Page',
            txtTemplateUserAgentLabel: 'User agent',
            txtCopyActionIdle: 'Copy template',
            txtCopyActionCopied: 'Copied',
            txtCopyActionFailed: 'Copy failed',
            txtCopyHelpFailed: 'Clipboard access was blocked. You can still select the text above and copy it manually.',
            txtCopyHelpIdle: 'Nothing here is sent automatically. This page just helps you format a good report.',
        },
    },
};
